import { render, staticRenderFns } from "./SidebarCaseCardDetail.vue?vue&type=template&id=cce08f3a&"
import script from "./SidebarCaseCardDetail.vue?vue&type=script&lang=js&"
export * from "./SidebarCaseCardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports